import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddOrderFormRoutingModule } from './add-order-form-routing.module';
import { AddOrderFormComponent } from './add-order-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalModule } from 'ngx-bootstrap/modal';


@NgModule({
  declarations: [
    AddOrderFormComponent
  ],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  exports: [
    AddOrderFormComponent
  ],
})
export class AddOrderFormModule { }
